import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";

export default function Login() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");
  const [animateTitle, setAnimateTitle] = useState(false);
  const [animateLogo, setAnimateLogo]   = useState(false);

  // Direct to Railway (HTTPS + correct /api path)
  const loginUrl = "https://ibl-backend-production.up.railway.app/api/login";

  useEffect(() => {
    setAnimateTitle(true);
    const t = setTimeout(() => setAnimateLogo(true), 500);
    return () => clearTimeout(t);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (loading) return;

    setError("");
    setLoading(true);

    try {
      const res = await axios.post(
        loginUrl,
        { username, password },
        {
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          timeout: 15000,                              // <- avoid infinite waits on mobile
          validateStatus: (s) => s >= 200 && s < 500,  // <- treat 4xx as handled error
        }
      );

      if (res?.data?.success) {
        localStorage.setItem("user", JSON.stringify(res.data.user));
        navigate("/dashboard"); // SPA nav (no full refresh)
      } else {
        const msg =
          res?.data?.message ||
          (res?.status ? `Login failed (HTTP ${res.status}).` : "Login failed.");
        setError(msg);
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Could not reach the server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen w-screen bg-black flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 bg-black">
        <canvas id="bg-animation" className="w-full h-full absolute" />
      </div>

      <form
        onSubmit={handleLogin}
        noValidate
        className="z-10 bg-[#0D0F1F] border border-blue-800 rounded-xl px-10 py-8 w-[350px] shadow-2xl text-white"
      >
        <div
          className={`flex flex-col items-center mb-6 transition-all duration-1000 ${
            animateLogo ? "translate-y-0 opacity-100" : "-translate-y-8 opacity-0"
          }`}
        >
          <img src={logo} alt="Logo" className="h-14 animate-bounce" />
          <h1
            className={`text-center text-xl font-bold mt-2 transition-opacity duration-1000 ${
              animateTitle ? "opacity-100" : "opacity-0"
            }`}
          >
            MT5Account <span className="text-blue-400">Information</span>
          </h1>
        </div>

        {error ? (
          <p className="text-red-500 mb-4 text-center text-sm">{error}</p>
        ) : null}

        <input
          type="text"
          className="w-full mb-4 px-4 py-2 rounded bg-[#1F2235] placeholder-gray-400 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          required
        />

        <input
          type="password"
          className="w-full mb-4 px-4 py-2 rounded bg-[#1F2235] placeholder-gray-400 text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full py-2 rounded font-semibold bg-gradient-to-r from-blue-500 to-purple-500 hover:opacity-90 transition duration-300 disabled:opacity-60"
        >
          {loading ? "Signing In..." : "Sign In"}
        </button>

        <div className="flex justify-between text-xs mt-3 px-1">
          <span className="text-green-400">🟢 System Online</span>
          <span className="text-blue-400">🔒 Secure Connection</span>
        </div>
      </form>
    </div>
  );
}
